import type { CivilDateRange } from '@sportninja/common/features/game/gameListView/types'

import type { GameViewMode } from '../hooks/useGameViewMode'

export interface GameListWindowInput {
  mode: GameViewMode
  /** True when the user picked an explicit Date Range rather than a period. */
  hasCustomDateRange: boolean
  /**
   * The window the filter row selects: the chosen Date Range, or the active
   * Past / Today / Upcoming period.
   */
  filterRange: CivilDateRange | null
  /** A BOUNDED calendar viewport — month, week or day — null everywhere else. */
  calendarRange: CivilDateRange | null
}

/**
 * Which civil window a view actually queries.
 *
 * Details is the deliberate odd one out. It is the bulk-edit surface, and a
 * selection cannot span two windows — so slicing a competition into Past /
 * Today / Upcoming would mean an admin can never renumber, relocate or shift a
 * season whose games sit on both sides of today, which is every season that is
 * currently being played. So with no explicit range it takes EVERY date the
 * other filters select; the Date Range picker is still there for narrowing, and
 * unlike the period tabs it says exactly which games it is about to include.
 */
export const resolveGameListWindow = (
  input: GameListWindowInput
): CivilDateRange | null => {
  //  An explicitly chosen date range is the user's own instruction and outranks
  //  both the calendar's viewport and the Details grid's whole-competition
  //  default.
  if (input.hasCustomDateRange) {
    return input.filterRange
  }

  if (input.mode === 'details') {
    return null
  }

  return input.calendarRange ?? input.filterRange
}
